"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactUseportal = _interopRequireDefault(require("react-useportal"));
var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));
var _useKeyPressHook = _interopRequireDefault(require("../../hooks/useKeyPressHook"));
var _AlertIconBadge = _interopRequireDefault(require("../../icons/AlertIconBadge"));
var _theme = _interopRequireDefault(require("../../theme"));
var _Heading = _interopRequireDefault(require("../Heading"));
var _Close = _interopRequireDefault(require("../../icons/Close"));
var _Arrow = _interopRequireDefault(require("../../icons/Arrow"));
var _styledComponents = require("./styled-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // @ts-ignore
// @ts-ignore
var Modal = function Modal(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$hasBackButton = _ref.hasBackButton,
    hasBackButton = _ref$hasBackButton === void 0 ? false : _ref$hasBackButton,
    _ref$hasHeader = _ref.hasHeader,
    hasHeader = _ref$hasHeader === void 0 ? true : _ref$hasHeader,
    _ref$hasTooltipHeader = _ref.hasTooltipHeader,
    hasTooltipHeader = _ref$hasTooltipHeader === void 0 ? false : _ref$hasTooltipHeader,
    _ref$isFullScreen = _ref.isFullScreen,
    isFullScreen = _ref$isFullScreen === void 0 ? false : _ref$isFullScreen,
    _ref$returnFocusOnClo = _ref.returnFocusOnClose,
    returnFocusOnClose = _ref$returnFocusOnClo === void 0 ? true : _ref$returnFocusOnClo,
    finalFocusRef = _ref.finalFocusRef,
    children = _ref.children,
    _ref$contentPaddingX = _ref.contentPaddingX,
    contentPaddingX = _ref$contentPaddingX === void 0 ? 'large' : _ref$contentPaddingX,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    _ref$onBackButton = _ref.onBackButton,
    onBackButton = _ref$onBackButton === void 0 ? function () {} : _ref$onBackButton,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'white' : _ref$background,
    _ref$hasMinHeight = _ref.hasMinHeight,
    hasMinHeight = _ref$hasMinHeight === void 0 ? true : _ref$hasMinHeight,
    videoSrc = _ref.videoSrc;
  var _usePortal = (0, _reactUseportal["default"])(),
    Portal = _usePortal.Portal;
  var _useState = (0, _react.useState)(isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var closeButtonRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setShowModal(isOpen);
  }, [isOpen]);
  var handleTransitionEnd = function handleTransitionEnd() {
    var _closeButtonRef$curre;
    return (_closeButtonRef$curre = closeButtonRef.current) === null || _closeButtonRef$curre === void 0 ? void 0 : _closeButtonRef$curre.focus();
  };
  var handleClose = function handleClose(event) {
    var _finalFocusRef$curren;
    setShowModal(false);
    onClose(event);
    finalFocusRef === null || finalFocusRef === void 0 || (_finalFocusRef$curren = finalFocusRef.current) === null || _finalFocusRef$curren === void 0 ? void 0 : _finalFocusRef$curren.focus();
  };
  var handleBackButton = function handleBackButton(event) {
    event.preventDefault();
    onBackButton(event);
  };
  (0, _useKeyPressHook["default"])('Escape', handleClose);
  var handleChild = function handleChild(event) {
    return event.stopPropagation();
  };
  var isVideoModal = !!videoSrc;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showModal && /*#__PURE__*/_react["default"].createElement(_reactFocusLock["default"], {
    returnFocus: returnFocusOnClose
  }, /*#__PURE__*/_react["default"].createElement(Portal, null, /*#__PURE__*/_react["default"].createElement(_styledComponents.Container, {
    "data-testid": "modal-overlay",
    onClick: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledGrid, {
    isFullScreen: isFullScreen,
    isVideoModal: isVideoModal
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledBoxModal, {
    onAnimationEnd: hasHeader || hasTooltipHeader ? handleTransitionEnd : undefined,
    role: "dialog",
    "aria-modal": "true",
    "aria-label": title,
    tabIndex: -1,
    isFullScreen: isFullScreen,
    onClick: handleChild,
    background: videoSrc ? 'transparent' : background,
    hasMinHeight: hasMinHeight
  }, hasHeader && !hasTooltipHeader ? /*#__PURE__*/_react["default"].createElement(_styledComponents.Header, {
    isFullScreen: isFullScreen,
    onlyCloseButton: !hasBackButton && !title,
    isVideoModal: isVideoModal
  }, hasBackButton && /*#__PURE__*/_react["default"].createElement(_styledComponents.Button, {
    "aria-label": "Go Back",
    onClick: handleBackButton
  }, /*#__PURE__*/_react["default"].createElement(_Arrow["default"], {
    color: _theme["default"].indigo60,
    size: 24
  })), title && !isVideoModal ? /*#__PURE__*/_react["default"].createElement(_styledComponents.Headline, {
    variant: "20"
  }, title) : null, /*#__PURE__*/_react["default"].createElement(_styledComponents.Button, {
    tabIndex: 0,
    "aria-label": "Close Modal",
    ref: closeButtonRef,
    onClick: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    color: isVideoModal ? 'white' : _theme["default"].indigo60,
    size: 24
  }))) : null, hasTooltipHeader ? /*#__PURE__*/_react["default"].createElement(_styledComponents.TooltipHeaderContainer, {
    "data-testid": "modal-tooltip-header"
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.TooltipHeaderCloseButton, {
    tabIndex: 0,
    "aria-label": "Close Modal",
    ref: closeButtonRef,
    onClick: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    color: _theme["default"].indigo60,
    size: 24
  })), /*#__PURE__*/_react["default"].createElement(_styledComponents.IconAndTitleWrapper, null, /*#__PURE__*/_react["default"].createElement(_AlertIconBadge["default"], {
    size: "large"
  }), /*#__PURE__*/_react["default"].createElement(_styledComponents.TooltipHeaderTitle, null, /*#__PURE__*/_react["default"].createElement(_Heading["default"], {
    variant: "40",
    as: "h1"
  }, title)))) : null, hasTooltipHeader ? /*#__PURE__*/_react["default"].createElement(_styledComponents.TooltipHeaderContent, null, children) : /*#__PURE__*/_react["default"].createElement(_styledComponents.Content, {
    isFullScreen: isFullScreen,
    spacing: contentPaddingX,
    hasHeader: hasHeader,
    isVideoModal: isVideoModal
  }, videoSrc ? /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledVideoWrapper, null, /*#__PURE__*/_react["default"].createElement("iframe", {
    title: title || 'Video',
    src: videoSrc,
    frameBorder: "0",
    allowFullScreen: true,
    "data-testid": "modal-video-iframe"
  })) : children)))))));
};
Modal.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  title: _propTypes["default"].string,
  hasBackButton: _propTypes["default"].bool,
  hasHeader: _propTypes["default"].bool,
  hasTooltipHeader: _propTypes["default"].bool,
  isFullScreen: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  contentPaddingX: _propTypes["default"].oneOf(['small', 'medium', 'large']),
  onClose: _propTypes["default"].func,
  onBackButton: _propTypes["default"].func,
  background: _propTypes["default"].string,
  hasMinHeight: _propTypes["default"].bool,
  videoSrc: _propTypes["default"].string,
  returnFocusOnClose: _propTypes["default"].bool
};
var _default = exports["default"] = Modal;